import { DataSource, Label, Layout, Panel, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutAuthorizationStatusQuickInfo extends Layout {
    labelLabel1: Label;
    panelColorDisplay: Panel;
    panelOrderTypeQuickInfo: Panel;
    sourceAuthorizationStatus: DataSource;
    textboxDescr: Textbox;
    textboxId: Textbox;
}
